export default __webpack_public_path__ + "./fonts/5b91b90ca9c385a6a0b2d51801fa0458.woff2";